import { custom } from 'devextreme/ui/dialog';

export default async function showConfirmDialog(options) {
  options.okButton = options.okButton||"Proceed";
  options.cancelButton = options.cancelButton||"Cancel";

  const dlg = custom({
    showTitle: false,
    messageHtml: `
      <div class="aim2-confirm-dialog-title">
        ${options.title}
      </div>
      <div class="aim2-confirm-dialog-message">
        ${options.message}
      </div>
    `,
    buttons: [{
      text: options.okButton,
      type: options.btnType || "default",
      onClick: () => true
    }, {
      text: options.cancelButton,
      onClick: () => false
    }],
    popupOptions: {  
      onShown: function() { }
    }  
  });
  return dlg.show();
}
